/* @flow */
import { selector } from 'lib/selectors';

const gs = (state) => state.googleSearch;
export const googleSearchItemsSelector = selector(gs, (e) => e.items);
export const googleSearchTextSelector = selector(gs, (e) => e.googleSearchText);
export const googlePanelStatusSelector = selector(gs, (e) => e.googlePanelStatus);
export const isGoogleSearchLoadingSelector = selector(gs, (e) => e.isGoogleSearchLoading);
